import { TileCoordinates } from "../runescape/coordinates";
export class GameMapEvent {
    constructor(map, leaflet, original) {
        this.map = map;
        this.leaflet = leaflet;
        this.original = original;
        this.active_entity = null;
        this.propagation_state = {
            phase: "pre",
            trickle_stopped_immediate: false,
            trickle_stopped: false,
            trigger_post_order: true
        };
    }
    handleFiltered(filter, handler) {
        if (filter(this))
            handler(this);
    }
    onPre(f) {
        this.handleFiltered(e => e.propagation_state.phase == "pre", f);
    }
    onPost(f) {
        this.handleFiltered(e => e.propagation_state.phase == "post", f);
    }
    stopAllPropagation() {
        this.original.stopPropagation();
        this.propagation_state.trickle_stopped = true;
        this.propagation_state.trickle_stopped_immediate = true;
        this.propagation_state.trigger_post_order = false;
    }
}
export class GameMapMouseEvent extends GameMapEvent {
    constructor(map, leaflet, coordinates) {
        super(map, leaflet, leaflet.originalEvent);
        this.leaflet = leaflet;
        this.coordinates = coordinates;
    }
    tile() {
        return TileCoordinates.snap(this.coordinates);
    }
}
export class GameMapKeyboardEvent extends GameMapEvent {
    constructor(map, leaflet) {
        super(map, leaflet, leaflet.originalEvent);
        this.leaflet = leaflet;
    }
}
export class GameMapContextMenuEvent extends GameMapEvent {
    constructor(map, leaflet, coordinates) {
        super(map, leaflet, leaflet.originalEvent);
        this.leaflet = leaflet;
        this.coordinates = coordinates;
        this.entries = [];
        this.title = "";
        this.for_entity_entries = [];
    }
    add(...entries) {
        this.entries.push(...entries);
    }
    addForEntity(...entries) {
        if (!this.active_entity)
            throw new TypeError("Adding entity actions for context menu without entity");
        this.for_entity_entries.push(...entries);
    }
    tile() {
        return TileCoordinates.snap(this.coordinates);
    }
    async getMenu() {
        const for_entity = await this.active_entity?.contextMenu(this);
        if (for_entity && (for_entity.children.length + this.for_entity_entries.length) > 0) {
            for_entity.children.push(...this.for_entity_entries);
            if (this.entries.length == 0) {
                return for_entity;
            }
            return {
                type: "submenu",
                text: this.title,
                children: this.entries.concat({
                    type: "submenu",
                    text: for_entity.text,
                    children: for_entity.children,
                })
            };
        }
        return {
            type: "submenu",
            text: this.title,
            children: this.entries
        };
    }
    setTitle(title) {
        this.title = title;
    }
}
export class GameMapViewChangedEvent extends GameMapEvent {
    constructor(map, old_view, new_view) {
        super(map, undefined, undefined);
        this.old_view = old_view;
        this.new_view = new_view;
        this.floor_changed = this.old_view?.rect?.level != this.new_view?.rect?.level;
        this.zoom_changed = this.old_view?.zoom != this.new_view?.zoom;
    }
}
